import NavigationBar from "../../components/navigationBar";
import OnsiteSEOComponent from "../../components/explainer-pages/onsiteSEOComponent";
import FooterView from "../../components/footerView";


export default function OnsiteSEO() {



    return (
        <div>

            <NavigationBar />
            <OnsiteSEOComponent />
            <FooterView />
        </div>
    )
}